import { AnalyticsRefDimension, CriteriaType, NetworkRef } from '../../../../state'
import { DepthRefFieldMapper, DepthRefGetterCallback, RefFieldMapperType } from './interfaces'

const getItemLabel: DepthRefGetterCallback<NetworkRef> = (item, depth) => {
    if (!item) {
        return undefined
    }
    switch (depth) {
        case 0:
            return item.network_name
    }
}

const getItemValue: DepthRefGetterCallback<NetworkRef> = (item, depth) => {
    if (!item) {
        return undefined
    }
    switch (depth) {
        case 0:
            return item.network_id
    }
}

const getItemTooltip: DepthRefGetterCallback<NetworkRef> = (item, depth) => {
    if (!item) {
        return undefined
    }
    switch (depth) {
        case 0:
            return getItemLabel(item, depth)
    }
}

export const NetworkRefFieldMapper: DepthRefFieldMapper<NetworkRef> = {
    type: RefFieldMapperType.Depth,
    dimension: AnalyticsRefDimension.NETWORK,
    criteriaType: CriteriaType.Network,
    table: 'patient',
    dateField: {},
    dateFieldInverse: {},
    searchPlaceholder: 'Search networks...',
    noResultsMessage: 'No networks found',
    searchHintMessage: 'Search by network name',
    filterFieldToRefField: {
        network: 'network_id'
    },
    filterFieldOrder: ['network'],
    filterLabelOrder: ['network'],
    getItemLabel,
    getItemValue,
    getItemTooltip
}
